import { Input } from '@starsoft/common/components';
import { handleChangeSearchValue } from '@/lib/store/casino/actions';
import { debounce } from 'lodash';
import { ChangeEvent, useCallback } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { useDispatch } from 'react-redux';

export default function GameSearchInput() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  //eslint-disable-next-line
  const debouncedFetch = useCallback(
    debounce(
      (nextValue: string) => dispatch(handleChangeSearchValue(nextValue)),
      500,
    ),
    [],
  );

  function handleGameSearchValue(e: ChangeEvent<HTMLInputElement>): void {
    debouncedFetch(e.target.value);
  }

  function onErase() {
    dispatch(handleChangeSearchValue(''));
  }

  return (
    <Input
      placeholder={t('game_provider_search_label') as string}
      onChange={handleGameSearchValue}
      isContainerColor
      icon="fad fa-search"
      showEraserButton
      onErase={onErase}
    />
  );
}
